import { Switch } from 'antd';
export function StateSwitch(props) {
  return <Switch checkedChildren="ON" unCheckedChildren="OFF" {...props} />;
}
export default StateSwitch;
